import { Action } from 'redux';
import { initializeState } from 'src/utils/Initial';
import { isType } from 'typescript-fsa';
import * as Actions from '../actions/testForm';

/**
 * eラーニングテストのState型
 */
export interface ITestFormState {
	readonly timeLimit: number;
	readonly retries: number;
	readonly testSetQuizCount: number;
	readonly startTime: string;
	readonly examStartTime: string;
	readonly thistoryID: number;
	readonly displayTmpSaveBtn: boolean;
	readonly groups: Actions.IGroup[];
	readonly markAfter: boolean;
	readonly questionGroupDisplay: boolean;

	readonly dbms: string | null;
	readonly cnt: number;
	readonly groupCount: number;
}

/**
 * eラーニングテストのState初期値
 */
const initialState: ITestFormState = {
	displayTmpSaveBtn: false,
	examStartTime: '',
	groups: [],
	markAfter: false,
	questionGroupDisplay: false,
	retries: 0,
	startTime: '',
	testSetQuizCount: 0,
	thistoryID: 0,
	timeLimit: 0,

	cnt: 0,
	dbms: '',
	groupCount: 0,
};

/**
 * eラーニングテスト用reducer
 * @param state State
 * @param action アクション
 */
const testForm = (state: ITestFormState, action: Action) => {
	if (!state) {
		// State初期化処理
		state = initialState;
		state = initializeState(state);
	}
	if (isType(action, Actions.setTestFormParams)) {
		return {
			...state,
			displayTmpSaveBtn: action.payload.displayTmpSaveBtn,
			examStartTime: action.payload.examStartTime,
			groups: action.payload.groups,
			markAfter: action.payload.markAfter,
			questionGroupDisplay: action.payload.questionGroupDisplay,
			retries: action.payload.retries,
			startTime: action.payload.startTime,
			testSetQuizCount: action.payload.testSetQuizCount,
			thistoryID: action.payload.thistoryID,
			timeLimit: action.payload.timeLimit,

			cnt: action.payload.cnt,
			dbms: action.payload.dbms,
			groupCount: action.payload.groupCount,
		};
	}

	if (isType(action, Actions.clearTestFormParams)) {
		return initialState;
	}

	return state;
};

export default testForm;



// WEBPACK FOOTER //
// ./src/reducers/testForm.ts